import React, { useState } from "react";
import { CheckIcon, StarIcon } from "./icons";

const PAGE = 6;

const initials = (n) =>
  n.split(/\s+/).map((w) => w[0]).filter(Boolean).join("").slice(0, 2).toUpperCase();

const ReviewCard = ({ t, index }) => (
  <article
    data-testid={`review-${index}`}
    className="bk-card rounded-2xl p-7 flex flex-col"
  >
    <div className="flex items-center gap-1 mb-4" aria-label="5 out of 5 stars">
      {[0, 1, 2, 3, 4].map((s) => (
        <StarIcon key={s} className="w-4 h-4 bk-star" />
      ))}
    </div>
    <p className="text-white/80 leading-relaxed text-[15px] flex-1">
      "{t.review}"
    </p>
    <div className="mt-6 pt-5 border-t border-white/10 flex items-center gap-3">
      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-gold/30 to-ink-700 border border-gold/30 flex items-center justify-center text-gold font-semibold text-sm">
        {initials(t.name)}
      </div>
      <div>
        <div className="text-sm font-semibold">{t.name}</div>
        {t.verified ? (
          <div className="flex items-center gap-1.5 text-[11px] text-gold/90 uppercase tracking-[0.18em]">
            <CheckIcon className="w-3 h-3" />
            Verified Review
          </div>
        ) : null}
      </div>
    </div>
  </article>
);

export default function WrittenTestimonials({ written = [] }) {
  const [shown, setShown] = useState(PAGE);
  const visible = written.slice(0, shown);
  const hasMore = shown < written.length;

  return (
    <section
      id="testimonials"
      data-testid="written-testimonials"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.28em] text-gold/80">Reviews</span>
          <h2 className="mt-4 font-display text-4xl md:text-5xl">
            Trusted by <span className="bk-gold-text italic">Growing Brands</span>
          </h2>
          <p className="mt-5 text-white/65 leading-relaxed">
            See what others are saying about their results with our systems.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {visible.map((t, i) => (
            <ReviewCard key={`${t.name}-${i}`} t={t} index={i} />
          ))}
        </div>

        {hasMore ? (
          <div className="mt-10 flex justify-center">
            <button
              onClick={() => setShown((s) => s + PAGE)}
              data-testid="load-more-reviews"
              className="text-xs uppercase tracking-[0.22em] font-semibold px-7 py-3.5 rounded-full border border-white/15 hover:border-gold hover:text-gold transition-colors text-white/80"
            >
              Load More Reviews · {written.length - shown} more
            </button>
          </div>
        ) : (
          written.length > PAGE ? (
            <div className="mt-10 text-center text-xs uppercase tracking-[0.22em] text-white/45">
              Showing all {written.length} reviews
            </div>
          ) : null
        )}
      </div>
    </section>
  );
}
